export const PROVIDER_PLANS = 'PROVIDER_PLANS'

export const ERROR_STATE = 'ERROR_STATE'
